export default {
  // 判断非空
  isNotEmpty: function (object) {
    return !this.isEmpty(object);
  },
  // 判断为空
  isEmpty: function (object) {
    // 类型判断 数组
    if (Array.isArray(object)) {
      if (object === undefined || object === [] || object.length === 0) {
        return true;
      }
    } else {
      if (object === undefined || object === null || object === ' ' || object === '') {
        return true;
      }
    }
    return false;
  }
}




// WEBPACK FOOTER //
// ./src/utils/StringUtils.js